import { useState } from 'react';
import { cn } from '@/lib/utils';

const ALTURA = {
  sm: 'h-[18px] max-w-[64px]',
  md: 'h-[28px] max-w-[112px]',
  lg: 'h-[56px] max-w-[200px]',
  // Prévia na edição do fornecedor: cabe num quadrado de 72px.
  quadro: 'max-h-[64px] max-w-[64px]',
} as const;

/**
 * A marca do fornecedor ao lado do nome curto. Sempre num fundo branco: logo de
 * empresa costuma ter fundo claro ou letra escura, e sumiria no tema escuro e
 * nas faixas escuras dos cartões. Sem logo (ou se ela falhar ao carregar), não
 * mostra nada — o nome curto já está sempre ao lado, então o alt fica vazio.
 */
export default function LogoFornecedor({
  logoUrl,
  apelido: _apelido,
  tamanho = 'md',
  className,
}: {
  logoUrl: string | null | undefined;
  apelido: string;
  tamanho?: keyof typeof ALTURA;
  className?: string;
}) {
  // Guarda qual endereço falhou, não só "falhou": uma logo nova que chega depois
  // de uma falha precisa ser tentada, sem esperar a tela remontar.
  const [falhou, setFalhou] = useState<string | null>(null);

  if (!logoUrl || falhou === logoUrl) return null;

  return (
    <span className={cn('inline-flex shrink-0 items-center justify-center rounded-md bg-white px-[4px] py-[2px]', className)}>
      <img src={logoUrl} alt="" onError={() => setFalhou(logoUrl)} className={cn('w-auto object-contain', ALTURA[tamanho])} />
    </span>
  );
}
